import React, { useState, useEffect } from 'react';
import {useParams, useSearchParams} from "react-router";

import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';

import ProfileFetch from '../../fetch/profileFetch';

import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import _ from "lodash";
import profileFetch from "../../fetch/profileFetch";
import Button from "@mui/material/Button";


function FundingModal(props) {
    const [funding, setFunding] = useState({});
    const [company, setCompany] = useState({});
    const [fundingNote, setFundingNote] = useState(null);
    const [roundValues, setRoundValues] = useState([]);
    const [investorOptions, setInvestorOptions] = useState([]);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [deleteMode, setDeleteMode] = useState(false);
    const [loading, setLoading] = React.useState(false);
    const [searchTimer, setSearchTimer] = React.useState(null);
    const [noteSent, setNoteSent] = React.useState(false);
    const [searchParams] = useSearchParams();

    const { orgId } = useParams();

    useEffect(() => {

        if (!props.open) {
            return;
        }

        /* eslint-disable */
        if (roundValues.length === 0) {
            ProfileFetch.getRoundValues().then(response=>{
                setRoundValues(response);
            })
        }
        if (props.fundingRoundToEdit) {
            let fundingCopy = _.cloneDeep(props.fundingRoundToEdit);
            fundingCopy.fundingDate = dayjs(fundingCopy.fundingDate);
            if (fundingCopy.maxValuation === 0) {
                fundingCopy.maxValuation = null;
            }

            if (props.fundingRoundToEdit.mentions && props.fundingRoundToEdit.mentions.length > 0) {
                fundingCopy.mention = props.fundingRoundToEdit.mentions[0].url;
            }

            setFunding(fundingCopy);
            if (props.investorMode) {
                setCompany({
                    "idCbiEntity": fundingCopy.idCbiEntity,
                    "idEntityDraft": fundingCopy.idEntityDraft,
                    "name": fundingCopy.entityName,
                    "url": fundingCopy.url,
                })
            } else {
                setCompany({
                    "idCbiEntity": props.profile.idCbiEntity,
                    "idEntityDraft": fundingCopy.idEntityDraft,
                    "name": props.profile?.entityNameInfo?.primaryName,
                    "url": props.profile.urlInfo.primaryUrl,
                })

                console.log(
                    {
                        "idCbiEntity": props.profile.idCbiEntity,
                        "idEntityDraft": fundingCopy.idEntityDraft,
                        "name": props.profile?.entityNameInfo?.primaryName,
                        "url": props.profile.urlInfo.primaryUrl,
                    }
                )
            }
        } else {
            if (props.investorMode) {
                setCompany({});
            } else {
                setCompany({
                    "idCbiEntity": props.profile.idCbiEntity,
                    "idEntityDraft": null,
                    "name": props.profile?.entityNameInfo?.primaryName,
                    "url": props.profile.urlInfo.primaryUrl,
                })
            }
            setFundingNote(null);

            if (props.investorMode && props.profile) {
                let investor = {
                    "idCbiEntity": props.profile.idCbiEntity,
                    "idInvestor": props.profile.idInvestor,
                    "name": props.profile.entityNameInfo.primaryName
                }

                setFunding({"investors": [investor]});
            }
        }

    }, [props.fundingRoundToEdit, props.open]);

    const handleClose = () => {
        setDeleteMode(false);
        setFunding({});
        setCompany({});
        setFundingNote(null);
        setLoading(false);

        if (searchTimer) {
            clearTimeout(searchTimer);
        }

        setSearchTimer(null);
        props.handleClose();
    }

    const updateFunding = (field, value) => {
        let fundingCopy = _.cloneDeep(funding);
        _.set(fundingCopy, field, value);
        setFunding(fundingCopy);
    }

    const isConvertibleToNumber = (str) => {
        if (str === null || str === "") {
            return false;
        }
        const num = Number(str);
        return !isNaN(num);
    }

    const isValidURL = (url) => {
        if (!url.includes(".")) {
            return false;
        }
        if (url.endsWith(".") || url.startsWith(".")) {
            return false;
        }

        try {
            if (url.startsWith('http://') || url.startsWith('https://')) {
                new URL(url);
            } else {
                new URL('http://' + url);
            }
            return true;
        } catch (error) {
            return false;
        }
    }

    const fundingIsValid = () => {
        if (!funding.investors || funding.investors.length === 0) {
            return false;
        }
        if (!isConvertibleToNumber(funding.amount)) {
            return false;
        }
        if (funding.maxValuation && funding.maxValuation !== '' && !isConvertibleToNumber(funding.maxValuation)) {
            return false;
        }
        if (!funding.fundingDate) {
            return false;
        }
        if (funding.fundingDate && !funding.fundingDate.isValid()) {
            return false;
        }
        if (!funding.fundingRound) {
            return false;
        }
        if (funding.mention && funding.mention !== '' && !isValidURL(funding.mention)) {
            return false;
        }
        if (!company) {
            return false;
        }
        if (company.generated && !isValidURL(company.proposedUrl)) {
            return false;
        }

        return true;
    }

    const saveFundingStepOne = () => {
        setLoading(true);

        if (company.generated) {
            profileFetch.updateEntity({
                    "createEntityShell": true,
                    "entityNameInfo": {
                        "primaryName": company.proposedUrl
                    },
                    "urlInfo": {
                        "primaryUrl": company.proposedUrl
                    },
                    "idPrimaryCbiEntityType": "COMPANY_ENTITY_TYPE"
                }, true
            ).then(response => {
                saveFundingStepTwo({
                    "idCbiEntity": response.idCbiEntity,
                    "idEntityDraft": response.idEntityDraft,
                    "name": response.entityNameInfo?.primaryName,
                    "url": response.urlInfo?.primaryUrl
                });
            }).catch(err => {
                props.setAlertMessage("Error saving funding. Please try again in a few minutes.")
            });
        } else {
            saveFundingStepTwo(company);
        }
    }

    const saveFundingStepTwo = (companyInfo) => {
        // need to convert our UI object to what the API wants first
        let fundingCopy = _.cloneDeep(funding);
        fundingCopy.fundingDate = fundingCopy.fundingDate.format("YYYY-MM-DD");

        if (funding.mention && funding.mention !== "") {
            let mention = funding.mention;
            if (!mention.startsWith('http://') && !mention.startsWith('https://')) {
                mention = "https://"+mention;
            }
            let mentions = [{"url": mention}];
            if (props.fundingRoundToEdit) {
                mentions = mentions.concat(props.fundingRoundToEdit.mentions);
            }
            fundingCopy.mentions = mentions;
        }

        fundingCopy.idCbiEntity = companyInfo.idCbiEntity;
        fundingCopy.idEntityDraft = companyInfo.idEntityDraft;
        fundingCopy.url = companyInfo.url;
        fundingCopy.entityName = companyInfo.name;

        profileFetch.updateFunding(
            companyInfo.idCbiEntity,
            companyInfo.idEntityDraft,
            fundingCopy,
            [],
            !props.investorMode,
            props.investorMode ? "INVESTOR_EDITOR" : "COMPANY_EDITOR"
        ).then(response => {
            props.onFundingsUpdated(response);
            handleClose();
        }).catch(err => {
            props.setAlertMessage("Error saving funding. Please try again in a few minutes.")
        });


        const eventDomain = props.investorMode ? "investorEditor" : "companyEditor";
        const event = {
            eventKey: props.fundingRoundToEdit ? `${eventDomain}.deal.updated` : `${eventDomain}.deal.created`,
            url: window.location.pathname,
            details: {
                campaignId: searchParams.get('campaignId'),
                campaignName: searchParams.get('campaignName'),
            }
        }
        profileFetch.recordEvent(event, orgId).then(response=>{}).catch(err => {});

        if (!noteSent) {
            let autoNote = "Fundings have been added and/or edited by " + props.profile?.entityNameInfo?.primaryName;
            profileFetch.addFundingNote(companyInfo.idCbiEntity, companyInfo.idEntityDraft, autoNote).then(response => {
                setNoteSent(true);
            }).catch(err => {

            });
        }

        if (fundingNote?.trim()) {
            profileFetch.addFundingNote(companyInfo.idCbiEntity, companyInfo.idEntityDraft, fundingNote).then(response => {

            }).catch(err => {
                props.setAlertMessage("Error saving funding. Please try again in a few minutes.")
            });
        }
    }

    const deleteFunding = () => {
        profileFetch.updateFunding(
            company.idCbiEntity,
            company.idEntityDraft,
            null,
            [funding.idFunding],
            !props.investorMode,
            props.investorMode ? "INVESTOR_EDITOR" : "COMPANY_EDITOR"
        ).then(response => {
            if (fundingNote?.trim()) {
                profileFetch.addFundingNote(company.idCbiEntity, company.idEntityDraft, fundingNote).then(response => {
                    props.onFundingsUpdated(response);
                    handleClose();
                })
            }
        });
    }

    const searchEntities = (searchTerm, companies) => {
        if (searchTimer) {
            clearTimeout(searchTimer);
        }

        if (companies) {
            setSearchTimer(setTimeout(()=>{searchCompany(searchTerm)}, 200));
        } else {
            setSearchTimer(setTimeout(()=>{searchInvestor(searchTerm)}, 200));
        }
    }

    const searchInvestor = (searchTerm) => {
        setLoading(true);
        profileFetch.searchEntity(searchTerm, 2).then(response=> {
            setLoading(false);
            setInvestorOptions(response);
        });
    }

    const searchCompany = (searchTerm) => {
        setLoading(true);
        profileFetch.searchEntity(searchTerm, 1).then(response=> {
            setLoading(false);
            setCompanyOptions(response);
        });
    }

    const getCompanyLabel = (company) => {
        let label = "";
        if (!company) {
            return label;
        }

        if (company.generated) {
            return company.displayName;
        }

        if (company.name) {
            label = company.name;
        }
        if (company.url) {
            label = label + " (" + company.url + ")";
        }
        return label;
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "80%",
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    };

    let welcomeText = props.fundingRoundToEdit ? "Edit Deal" : "Add New Deal";

    return (
        <Modal
            open={props.open}
            onClose={handleClose}
        >
            <Paper sx={style}>
                <Typography
                    variant={'h5'}
                    sx={{marginLeft: "6px", marginTop: "6px"}}
                >
                    {welcomeText}
                </Typography>
                <hr style={{borderColor: "#111" , marginTop: "16px", marginBottom: "32px"}}/>
                {props.investorMode && !props.fundingRoundToEdit &&
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "left"}}>
                        <Typography
                            variant={'h6'}
                            sx={{marginLeft: "6px", marginTop: "10px", marginRight: "16px"}}
                        >
                            Select the company
                        </Typography>
                        <Autocomplete
                            selectOnFocus
                            clearOnBlur
                            handleHomeEndKeys
                            freeSolo
                            disablePortal
                            options={companyOptions}
                            getOptionLabel={(option) => getCompanyLabel(option)}
                            sx={{ width: 300, marginRight: "8px", marginBottom: "48px" }}
                            onInputChange={(event, value) => searchEntities(value, true) }
                            value={company}
                            onChange={(event, value) => {
                                setCompany(value);
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    disabled={company?.name}
                                    label="Company"
                                />
                            }
                            filterOptions={(options, params) => {
                                const filtered = options;

                                const { inputValue } = params;
                                const isExisting = options.some(
                                    (option) => option.name.startsWith(inputValue) || option.url.startsWith(inputValue)
                                );
                                if (inputValue !== '' && !isExisting) {
                                    filtered.push({
                                        name: inputValue,
                                        displayName: `Create "${inputValue}"`,
                                        url: ``,
                                        proposedUrl: inputValue,
                                        generated: true
                                    });
                                }

                                return filtered;
                            }}
                        />
                        {company && company.generated && !isValidURL(company.proposedUrl) && <Typography
                            variant={'p'}
                            sx={{marginRight: "16px", marginTop: "18px", color: "rgb(211, 47, 47)"}}
                        >
                            When adding a new company, you must enter a valid URL.
                        </Typography>}
                    </div>
                }

                {props.investorMode && props.fundingRoundToEdit &&
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "left"}}>
                        <Typography
                            variant={'h6'}
                            sx={{marginLeft: "6px", marginTop: "10px", marginRight: "16px", marginBottom: "16px"}}
                        >
                            {funding.entityName}
                        </Typography>
                    </div>
                }

                <div style={{display: "flex", flexDirection: "row", justifyContent: "left", "margin": "6px"}}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                        <DatePicker
                            sx={{marginRight: "8px"}}
                            value={funding.fundingDate}
                            onChange={(date) => updateFunding('fundingDate', date)}
                        />
                    </LocalizationProvider>

                    <Autocomplete
                        disablePortal
                        options={roundValues}
                        getOptionLabel={(option) => option.name}
                        sx={{ width: 250, marginRight: "8px" }}
                        value={funding.fundingRound}
                        onChange={(event, value) => updateFunding('fundingRound', value)}
                        renderInput={(params) => <TextField {...params} label="Round Type" />}
                    />

                    <TextField
                        error={funding.amount && funding.amount !== "" && !isConvertibleToNumber(funding.amount)}
                        sx={{marginRight: "8px"}}
                        id="outlined-basic"
                        label="Amount (USD Millions)"
                        variant="outlined"
                        value={funding.amount}
                        onChange={(event)=> {updateFunding("amount", event.target.value)}}
                    />

                    <TextField
                        error={funding.maxValuation && funding.maxValuation !== "" && !isConvertibleToNumber(funding.maxValuation)}
                        sx={{marginRight: "8px"}}
                        id="outlined-basic"
                        label="Valuation (USD Millions)"
                        variant="outlined"
                        value={funding.maxValuation}
                        onChange={(event)=> {updateFunding("maxValuation", event.target.value)}}
                    />

                    <Autocomplete
                        multiple
                        disablePortal
                        options={investorOptions}
                        getOptionLabel={(option) => getCompanyLabel(option)}
                        sx={{ width: 250, marginRight: "8px" }}
                        onInputChange={(event, value) => searchEntities(value, false) }
                        value={funding.investors}
                        onChange={(event, value) => updateFunding('investors', value)}
                        renderInput={(params) => <TextField {...params} label="Investors" />}
                    />

                    <TextField
                        error={funding.mention && funding.mention !== "" && !isValidURL(funding.mention)}
                        sx={{marginRight: "8px"}}
                        id="outlined-basic"
                        label="News Article"
                        variant="outlined"
                        value={funding.mention}
                        onChange={(event)=> {updateFunding("mention", event.target.value)}}
                    />

                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "left", "marginTop": "16px"}}>
                    <TextField
                        error={deleteMode && !fundingNote?.trim()}
                        fullWidth
                        id="outlined-multiline-flexible"
                        label="Notes"
                        placeholder="Any further information..."
                        multiline
                        maxRows={3}
                        value={fundingNote}
                        onChange={(event)=> {setFundingNote(event.target.value)}}
                    />
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", "margin": "6px"}}>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "right", "margin": "6px"}}>
                        {props.fundingRoundToEdit && !deleteMode &&
                            <Button variant="outlined" color="error"
                                    sx={{marginTop: "28px", marginLeft: "4px"}}
                                    onClick={() => {setDeleteMode(true)}}
                                    disabled={!funding.idFunding}
                            >
                                Delete Deal
                            </Button>
                        }
                    </div>
                    {!deleteMode &&
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "right", "margin": "6px"}}>
                            {loading && <CircularProgress sx={{marginTop: "32px", marginRight: "8px"}} color="inherit" size={20}/>}
                            <Button variant="outlined"
                                    sx={{marginTop: "28px"}}
                                    onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            <Button variant="contained"
                                    sx={{marginTop: "28px", marginLeft: "4px"}}
                                    onClick={saveFundingStepOne}
                                    disabled={!fundingIsValid()}
                            >
                                Save
                            </Button>
                        </div>
                    }
                    {deleteMode &&
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "right", "margin": "6px", alignItems: "center"}}>
                            <Typography
                                variant={'p'}
                                sx={{marginRight: "16px", marginTop: "24px", color: "rgb(211, 47, 47)"}}
                            >
                                Are you sure you want to delete this deal?
                            </Typography>
                            <Button variant="outlined"
                                    sx={{marginTop: "28px"}}
                                    onClick={() => {setDeleteMode(false)}}
                            >
                                No
                            </Button>
                            <Button variant="contained"
                                    sx={{marginTop: "28px", marginLeft: "4px"}}
                                    onClick={deleteFunding}
                                    disabled={!fundingNote?.trim()}
                            >
                                Yes
                            </Button>
                        </div>
                    }
                </div>
            </Paper>
        </Modal>
    )

}

export default FundingModal;